import * as React from "react";
import {cx} from "emotion";

import "./redirect-url.scss";

import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {validateUrlFormat} from "@Common/react/cs-form-2/validators/url-format-validation";
import {fragments}         from "@Common/react/fragments";
import {Invoke}            from "@Common/react/invoke";
import {keyed}             from "@Common/react/keyed";
import {IndependentList}   from "@Common/react/shadow/independent-list";
import {scnv}              from "@Common/react/state-change-nested-value";
import {UseState}          from "@Common/react/use-state";
import {Radio}             from "@Common/ui-components/heavy/common/design2/radio/radio";
import {groupEditors}      from "@Common/ui-components/heavy/common/group-editors";
import {cnv}               from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";

import {setCurrentToSaved} from "../set-current-to-saved";

import {TypeHomevalue}   from "./types/type-homevalue/type-homevalue";
import {TypeUrl}         from "./types/type-url/type-url";
import {TypeXpresslinks} from "./types/type-xpresslinks/type-xpresslinks";

export const RedirectURL = ({itemId, initData, next}) => cs(
    ["typeState", (_, next) => UseState({
        getInitValue: () => chain(
            initData?.redirectType,
            (_) => ({
                saved: _,
                current: _ || "xpresslinks",
            }),
        ),
        next,
    })],

    ["types", ({typeState}, next) => IndependentList({
        list: [
            {
                name: "url",
                render: ({disabled, next}) => cs(
                    ["typeUrl", (_, next) => TypeUrl({
                        disabled,
                        liveValue: initData?.redirectUrl,
                        path: ["redirectUrl"],
                        next,
                    })],
                    ({typeUrl}, next) => fragments(
                        next(),
                        typeUrl.renderUrlState((urlState) => cs(
                            consumeContext("session"),
                            ({session}) => (
                                session?.data?.agent?.agentDisplay8 && Invoke({
                                    action: () => {
                                        if (!urlState.value && validateUrlFormat(session.data.agent.agentDisplay8)) {
                                            scnv(urlState, [], () => session.data.agent.agentDisplay8);
                                        }
                                        // console.log("agent", session.data?.agent);
                                    },
                                })
                            ),
                        )),
                    ),
                    ({typeUrl}) => next(typeUrl),
                ),
            },
            {
                name: "xpresslinks",
                render: ({next}) => TypeXpresslinks({
                    itemId,
                    next,
                }),
            },
            {
                name: "homevalue",
                render: ({disabled, next}) => TypeHomevalue({
                    disabled,
                    itemId,
                    next,
                }),
            },
        ].map((type) => ({
            key: type.name,
            render: (next) => cs(
                ["disabled", (_, next) => next(type.name !== typeState.value.current)],
                ["ret", ({disabled}, next) => type.render({
                    disabled,
                    next,
                })],
                ({ret, disabled}) => next({
                    ...ret,
                    name: type.name,
                    disabled,
                })
            ),
        })),
        next,
    })],

    ({typeState, types}) => next({
        editor: groupEditors([
            {
                $name: "Informed Delivery > Redirect URL > type",
                valid: true,

                changed: typeState.value?.saved !== typeState.value?.current,
                prepareSave: (data) => ({
                    newValue: chain(
                        data,
                        (_) => cnv(_, ["redirectType"], () => typeState.value?.current),
                    ),
                    onSaved: () => setCurrentToSaved(typeState),
                }),
            },
            ...types.filter((t) => !t.disabled && t.editor).map((t) => t.editor),
        ]),
        activeUrl: types?.find((t) => !t.disabled)?.activeUrl,
        render: ({showErrors}) => cs(
            ({}) => (
                <div className="redirect-url-14j">
                    {types.map((type) => cs(
                        keyed(type.name),
                        ({}, next) => type.hidden ? null : next(),
                        () => (
                            <div {...{
                                className: cx("option", {"static": type.staticControl}),
                                onClick: () => scnv(typeState, ["current"], () => type.name),
                            }}>
                                <div className="line1">
                                    {Radio({
                                        selected: !type.disabled,
                                        xdQaName: "Redirect URL - " + type.name,
                                    })}

                                    {type.renderControl({
                                        showErrors,
                                        itemId,
                                    })}
                                </div>

                                {!type.disabled && type.errorHandling && (
                                    <div className="error">
                                        <div {...{
                                            className: cx("message", {inactive: type.editor.valid}),

                                            "xd-qa-type": "text",
                                            "xd-qa-name": "Redirect URL Error",
                                        }}>
                                            {type.errorHandling.message}
                                        </div>

                                        {type.errorHandling.controls && (
                                            <div className="controls">
                                                {type.errorHandling.controls}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ),
                    ))}
                </div>
            ),
        ),
    }),
);



